import { BigNumber } from 'ethers'

export function accumulateFloorPrice(currentFloor, listings, currencyAddress) {
    let floor = currentFloor
    for (const listing of listings) {
        if (!listing.active || listing.currency.toLowerCase() !== currencyAddress.toLowerCase()) continue
        if (floor === null || listing.price.lt(floor)) floor = listing.price
    }
    return floor
}

export function accumulateRecentVolume(currentVolume, sales, currencyAddress, cutoff) {
    let volume = BigNumber.from(currentVolume)
    for (const sale of sales) {
        if (sale.soldAt >= cutoff && sale.currency.toLowerCase() === currencyAddress.toLowerCase()) {
            volume = volume.add(sale.price)
        }
    }
    return volume
}

export function shouldContinueSalesScan(sales, cutoff) {
    return sales.length > 0 && sales[0].soldAt >= cutoff
}
